import config from 'config'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import queryString from 'query-string'

import { resetClass } from 'srcReact/helpers/utils'
import { alertActions } from 'srcReact/Alert'
import { subscriptionActions } from 'srcReact/SubscriptionPage'
import { organizationActions } from 'srcReact/OrganizationPage'
import Spinner from 'srcReact/components/common2/Spinner'

class CallbackCheckoutPageContainer extends Component {
  constructor(props) {
    super(props)
    this.state = { redirectHome: false }

    let query = queryString.parse(location.search)
    if (query && query.organization_id && query.id && query.state) {
      this.props.createSubscription(query.organization_id, query.id, query.state)
    } else {
      //this.state.redirectHome = true
      this.props.errorAlerts(this.props.t('error.not_authorized'))
      //window.location = `${config.webUrl}`
    }

    resetClass(document.body, 'callback-checkout-page')
  }

  componentDidMount() {
    const { current_organization, getWorkplaces } = this.props

    getWorkplaces(current_organization.info.resourceKey)
  }

  componentWillUnmount() {
    document.body.classList.remove('callback-checkout-page')
  }

  componentDidUpdate() {
    const { subscriptionPlan, current_organization, workplace_list } = this.props
    if (subscriptionPlan && subscriptionPlan.loaded) {
      setTimeout(function () {
        if (workplace_list.items.length === 5) {
          window.location = `${config.webUrl}/0/workplaces`
        } else {
          window.location = `${config.webUrl}/0/create-workplace?organization_id=${current_organization.info.resourceKey}`
        }
      }, 2000)
    }
  }

  render() {
    const { t, alert, user, subscriptionPlan } = this.props
    const { redirectHome } = this.state
    return (
      <React.Fragment>
        {!redirectHome && subscriptionPlan && subscriptionPlan.error && (
          <p className='mt-3 alert alert-danger text-center'>{t('error.occured')}</p>
        )}
        {alert && alert.message && (
          <div className='d-flex justify-content-center align-items-start pt-3'>
            <p className='alert alert-danger text-center'>
              {alert.message}
              <br />
              {redirectHome && <Spinner />}
            </p>
          </div>
        )}

        {!redirectHome && subscriptionPlan && (subscriptionPlan.loading || subscriptionPlan.loaded) && (
          <div className='loader-container d-flex justify-content-center align-items-center pt-3'>
            <p className='text-center text-green mb-0'>
              {subscriptionPlan.loaded && (
                <React.Fragment>
                  {t('billing.pricing.checkout.planSave')}
                  <br />
                </React.Fragment>
              )}
              <Spinner />
            </p>
          </div>
        )}
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  const { alert, organization, subscription } = state
  const { current_organization, workplace_list } = organization
  const { loggingIn, user } = state.login
  const { subscriptionPlan } = subscription
  return { alert, loggingIn, user, current_organization, subscriptionPlan, workplace_list }
}

const actionCreators = {
  clearAlerts: alertActions.clear,
  errorAlerts: alertActions.error,
  createSubscription: subscriptionActions.createAfterCheckout,
  getWorkplaces: organizationActions.getWorkplaces
}

const ExtendedComponent = withTranslation('common')(CallbackCheckoutPageContainer)

const connectedCallbackCheckoutPageContainer = connect(mapStateToProps, actionCreators)(ExtendedComponent)
export { connectedCallbackCheckoutPageContainer as CallbackCheckoutPageContainer }
